import React, {FC} from 'react';

import {OpenFilterDrawerAction} from '../open-filter-drawer/open-filter-drawer';
import {ITableActionProps} from '../table-action-types';
import {IntegratedFilter} from './integrated-filter';

export const Filter: FC<ITableActionProps> = ({
    meta,
    url,
    parentEntityType,
    entityName,
    ...props
}: ITableActionProps) => {
    const {isIntegratedFilter} = meta;

    return (
        <>
            {isIntegratedFilter ? (
                <IntegratedFilter
                    url={url}
                    parentEntityType={parentEntityType}
                    entityName={entityName}
                    spacingValue="small"
                    {...props}
                />
            ) : (
                <OpenFilterDrawerAction
                    meta={meta}
                    entityName={entityName}
                    {...props}
                />
            )}
        </>
    );
};
